import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalAuthButton',
  props: {
    title: null,
    action: null,
    imgSrc: null
  },
  emits: ['login'],
  setup(__props: any) {




return { __sfc: true, }
}

})